<template>
    <!-- topbar -->
    <div id="topbar">
        <div class="container" v-if="isLogin">
            <div class="row align-items-center">
                <div class="col-12 col-md-6 topbar-left text-center text-md-left">
                    <div class="row">
                        <div class="col-12 col-md-5 col-lg-4">
                            <a class="brand" @click="toHome">
                                <img src="@/assets/img/logo-darmasiswa-putih.png" alt="Logo Darmasiswa">
                            </a>
                        </div>
                        <div class="col-12 col-md-7 col-lg-8">
                            <div class="input-group md-form form-sm form-2 pl-0">
                                <input class="form-control my-0 py-1 red-border" type="text" placeholder="Search" aria-label="Search" v-model="form.q" @keyup.enter="onSearch">
                                <div class="input-group-append">
                                    <span class="input-group-text red lighten-3" id="basic-text1"><i class="fas fa-search text-grey"
                                        aria-hidden="true"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 topbar-right text-center text-md-right">
                    <ul class="list-inline">
                        <li class="list-inline-item">
                            <a @click="toProfile" class="profile">
                                <img :src="dataUser.photo_profile || '@/assets/img/hopper.jpg'" alt="Avatar Profile">
                                <span>{{ dataUser.full_name }}</span>
                            </a>
                        </li>
                        <li class="list-inline-item">
                            <a @click="clickTab('message')" class="text-dark"><i class="fa fa-envelope"></i>&nbsp;<span class="badge badge-danger" v-if="messageUnread > 0">{{ messageUnread }}</span></a>
                            <div :class="tabShow('message')">
                                <div class="dropdown-big">
                                    <h6>Messages</h6>
                                    <hr>
                                    <div class="dropdown-content" v-if="messageUnread > 0">
                                        <div v-for="(item, index) in message" :key="index" class="mb-2" v-if="index <= 5">
                                            <div v-for="(cc, indexx) in item.participants" :key="indexx" v-if="cc.id !== dataUser.id" class="row">
                                                <div class="col-md-4">
                                                    <img :src="cc.photo_profile" :alt="cc.full_name" class="img-fluid">
                                                </div>
                                                <div class="col-md-8 text-left">
                                                    <h6>{{ cc.full_name }}</h6>
                                                    <p>{{ item.last_message.body }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <a @click="toMessage">See All Messages</a>
                                    </div>
                                    <div class="dropdown-content" v-else>
                                        <p>Nothing to Show</p>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="list-inline-item">
                            <a @click="clickTab('notification')" class="text-dark"><i class="fa fa-bell"></i>&nbsp;<span class="badge badge-danger" v-if="notificationUnread > 0">{{ notificationUnread }}</span></a>
                            <div :class="tabShow('notification')">
                                <div class="dropdown-big">
                                    <h6>Notifications</h6>
                                    <hr>
                                    <div class="dropdown-content" v-if="notification.length > 0">
                                        <div v-for="(item, index) in notification" :key="index" v-if="index <= 5">
                                            <p>{{ item.body }}</p>
                                        </div>
                                        <div class="dropdown-divider"></div>
                                        <a @click="toNotification">See All Notification</a>
                                    </div> 
                                    <div class="dropdown-content" v-else>
                                        <p>Nothing to Show</p>
                                    </div> 
                                </div>
                            </div>
                        </li>
                        <li class="list-inline-item">
                            <a @click="clickTab('info')" class="text-dark"><i class="fa fa-caret-down"></i></a>
                            <div :class="tabShow('info')">
                                <div class="dropdown-big">
                                    <ul class="utils">
                                        <li><a v-if="dataUser.isAdmin !== 0" @click="toAdmin">Administrator</a></li>
                                        <li><a @click="toSettingProfile" class="text-dark">Setting Profile</a></li>
                                        <li><a @click="onLogout" class="text-dark">Logout</a></li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="container" v-else>
            <div class="row align-items-center">
                <div class="col-12 topbar-left text-center p-2">
                    <div class="row">
                        <div class="col-12">
                            <a class="brand" href=".">
                                <img src="@/assets/img/logo-darmasiswa-putih.png" alt="Logo Darmasiswa">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Topbar -->
</template>

<script>
export default {
    data() {
        return {
            tab: '',
            form: {
                q: '',
            },
            message: [],
            messageUnread: 0,
            notification: [],
            notificationUnread: 0,
        }
    },
    computed: {
        isLogin: function () {
            return this.$store.state.isLogin;
        },
        dataUser: function () {
            if (this.isLogin) {
                return this.$store.state.dataUser;
            } else {
                return [];
            }
        },
    },
    created() {
        this.$store.commit('setIsLogin');
        if (this.isLogin) {
            this.$store.commit('setDataUser');
            this.checkMessage();
            this.checkNotification();
        }
    },
    methods: {
        onLogout() {
            localStorage.clear();
            this.$router.push({name: 'login'});
        },
        clickTab(type) {
            if (type === 'message') {
                if (this.tab === 'message') {
                    this.tab = '';
                } else {
                    this.tab = 'message';
                }
            } else if (type === 'notification') {
                if (this.tab === 'notification') {
                    this.tab = '';
                } else {
                    this.tab = 'notification';
                    this.seenNotification();
                }
            } else {
                if (this.tab === 'info') {
                    this.tab = '';
                } else {
                    this.tab = 'info';
                }
            }
        },
        tabShow(type) {
            if (type === 'message') {
                if (this.tab === 'message') {
                    return {
                        'dropdown-nav' : true,
                        'fadein' : true,
                        'fadeout' : false,
                    }
                } else {
                    return {
                        'dropdown-nav' : true,
                        'fadein' : false,
                        'fadeout' : true,
                    }
                }
            } else if (type === 'notification') {
                if (this.tab === 'notification') {
                    return {
                        'dropdown-nav' : true,
                        'fadein' : true,
                        'fadeout' : false,
                    }
                } else {
                    return {
                        'dropdown-nav' : true,
                        'fadein' : false,
                        'fadeout' : true,
                    }
                }
            } else {
                if (this.tab === 'info') {
                    return {
                        'dropdown-nav' : true,
                        'fadein' : true,
                        'fadeout' : false,
                    }
                } else {
                    return {
                        'dropdown-nav' : true,
                        'fadein' : false,
                        'fadeout' : true,
                    }
                }
            }
        },
        toHome() {
            this.$router.push({name: 'home'});
        },
        toProfile() {
            this.$router.push({name: 'profile', params: { type: 'timeline' }});
        },
        toSettingProfile() {
            this.$router.push({name: 'setting-profile'});
        },
        toAdmin() {
            this.$router.push({name: 'administrator', params: { type: 'search-user' }});
        },
        onSearch() {
            this.$router.push({name: 'search', params: { q: this.form.q }});
        },
        toMessage() {
            this.$router.push({name: 'message'});
        },
        toNotification() {
            this.$router.push({name: 'notification'});
        },
        async checkMessage() {
            this.message = [];

            let payload = {
                scope: 'load',
                data: {
                    access_token: this.dataUser.access_token,
                },
            };

            try {
                let load = await this.$store.dispatch('message', payload);
                if (load.data.status) {
                    this.message = load.data.data;
                    this.messageUnread = load.data.unreadCount;
                } else {
                    this.$bvToast.toast('Load Message Notification Failed! Please refresh the page!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.$bvToast.toast('Load Message Notification Failed! Please refresh the page!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async seenNotification() {
            let payload = {
                scope: 'markSeen',
                data: {
                    access_token: this.dataUser.access_token,
                    user_id: this.dataUser.id,
                },
            };

            try {
                let load = await this.$store.dispatch('message', payload);
                if (load.data.status) {
                    this.checkNotification();
                } else {
                    this.$bvToast.toast('Load Message Notification Failed! Please refresh the page!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.$bvToast.toast('Load Message Notification Failed! Please refresh the page!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async checkNotification() {
            this.notification = [];
            this.notificationUnread = 0;

            let payload = {
                scope: 'loadNotification',
                data: {
                    access_token: this.dataUser.access_token,
                    user_id: this.dataUser.id,
                },
            };

            try {
                let load = await this.$store.dispatch('message', payload);
                if (load.data.status) {
                    this.notification = load.data.message;
                    if (load.data.message.length > 0) {
                        load.data.message.forEach((m) => {
                            if (m.is_seen !== '1') {
                                this.notificationUnread += 1;
                            }
                        });
                    }
                } else {
                    this.$bvToast.toast('Load Notification Failed! Please refresh the page!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.$bvToast.toast('Load Notification Failed! Please refresh the page!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        }
    }
}
</script>

<style scoped>
@-webkit-keyframes fadein {
    from { opacity: 0; }
    to { opacity: 1; }
}

@-webkit-keyframes fadeout {
    from { opacity: 1; }
    to { opacity: 0; }
}

.fadeout {
    display: none;
    -webkit-animation-name: fadeout;
    -moz-animation-name: fadeout;
}

.fadein {
    opacity: 1;
    display: block;
    -webkit-animation-name: fadein;
    -moz-animation-name: fadein;
}
</style>